import React from 'react';
import { XIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { painPoints, objections } from '../data/content';
export function ProblemSection() {
  return <section aria-labelledby="problema" className="border-y border-line bg-canvasAlt" data-id="element-227" data-mp="30h7odx4u28y9">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-10" data-id="element-228" data-mp="2vqr6o0tzc163">
        <div className="grid gap-8 lg:grid-cols-2 lg:gap-12" data-id="element-229" data-mp="2voehb2lw6oj0">
          <Reveal data-id="element-230" data-mp="39gkwomh80rhe">
            <h2 id="problema" className="font-display text-2xl md:text-3xl font-extrabold uppercase leading-tight text-ink" data-id="element-231" data-mp="39g2rv1ght4xv">
              Si te interesa la Electrónica, probablemente te pasó esto
            </h2>
            <ul className="mt-4 divide-y divide-line border-y border-line" data-id="element-232" data-mp="3egh46vp4n11p">
              {painPoints.map(point => <li key={point} className="flex items-start gap-2.5 py-2.5 text-sm md:text-base text-ink-muted" data-id="element-233" data-mp="1p2u1auhwlxja">
                  <XIcon size={16} className="mt-1 flex-shrink-0 text-danger" strokeWidth={2.5} data-id="element-234" data-mp="jddbm61f48uh" />
                  <span data-id="element-235" data-mp="o9u0x3kcst95">{point}</span>
                </li>)}
            </ul>
            <p className="mt-4 font-display text-lg md:text-xl font-extrabold uppercase leading-snug text-accent" data-id="element-236" data-mp="sbp2m96758ng">
              Sabés que la Electrónica tiene potencial, pero no sabés cómo
              aprovecharlo.
            </p>
          </Reveal>

          <Reveal delay={0.06} data-id="element-237" data-mp="171mvh2f2mmiz">
            <div className="rounded-2xl border border-line bg-surface p-6" data-id="element-238" data-mp="170v09spdyqt8">
              <h3 className="font-display text-xl md:text-2xl font-extrabold uppercase leading-tight text-ink" data-id="element-239" data-mp="1c33vywtn86z1">
                No es falta de capacidad.
                <br data-id="element-240" data-mp="3dt5lspwptkoo" />
                Tampoco es que “la Electrónica no sea para vos”.
              </h3>
              <p className="mt-3 text-base text-ink-muted" data-id="element-241" data-mp="3huha8s3urzva">
                El problema es que mucha de la información disponible está:
              </p>
              <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-242" data-mp="p0sgh111lkpe">
                {objections.map(obj => <li key={obj} className="flex items-center gap-2 rounded-lg bg-surface-alt px-3 py-2 text-sm text-ink-muted" data-id="element-243" data-mp="k30jvtpgdaev">
                    <XIcon size={14} className="flex-shrink-0 text-danger" strokeWidth={2.5} data-id="element-244" data-mp="txsgovb7nt8l" />
                    <span data-id="element-245" data-mp="12z094wr1pzur">{obj}</span>
                  </li>)}
              </ul>
              <p className="mt-4 text-base text-ink-muted" data-id="element-246" data-mp="1hnwhyw0xfgwf">
                Podés pasar meses consumiendo información y seguir sin terminar
                tu primer proyecto serio. Saber Electrónica es una cosa:
              </p>
              <p className="mt-2 font-display text-lg font-extrabold text-volt" data-id="element-247" data-mp="1qpw2hyb5h344">
                saber qué hacer con ese conocimiento es otra.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}